import { open } from "../../domain/modal/modalModel";
import { UpdateModalOpenStore, updateModalUseCase } from "./updateOpenModalUseCase";

const openModalUseCase = (store: UpdateModalOpenStore) => {
    return updateModalUseCase(store, open)
}

export { openModalUseCase }